/* === Sunny Cords — Kaching Bundles free-shipping trigger ===
   Inside the SELECTED bundle box: shows "Nog €X tot gratis verzending" while the
   chosen total is under the free-shipping threshold, and confirms the
   free-shipping value once reached. The threshold and currency come from the
   cart drawer bar (snippets/free-shipping-bar.liquid, per market through the
   custom.free_shipping_threshold market metafield); without a bar there is no
   reliable threshold and the note stays hidden.
   It also localizes Kaching's euro amounts and second-item button for Dutch.
   Styling lives in custom.css (.sc-free-shipping). Selectors mirror Kaching's
   markup; the widget renders in-page so we read its DOM directly. */
(function () {
  // Teksten komen vertaald uit layout/theme.liquid (window.SC_TXT, locale-keys cart.general.free_shipping_*); Nederlands als fallback.
  var SC_TXT = window.SC_TXT || {};
  // Shopify escapet apostrofs e.d. in vertalingen (d&#39;une) → terug naar leesbare tekst.
  function decodeEntities(s) { if (!s || s.indexOf('&') === -1) return s; var el = document.createElement('textarea'); el.innerHTML = s; return el.value; }
  var TXT_REACHED_EUR = decodeEntities(SC_TXT.reachedEur) || '✓ Gratis verzending (t.w.v. €4,95)';
  var TXT_REACHED = decodeEntities(SC_TXT.reached) || '✓ Gratis verzending';
  var TXT_LEFT = decodeEntities(SC_TXT.left) || 'Nog %AMOUNT% tot gratis verzending';

  function config() {
    var bar = document.querySelector('[data-free-shipping-bar]');
    if (!bar) return null;
    var cents = parseInt(bar.getAttribute('data-threshold'), 10);
    if (!cents || isNaN(cents)) return null;
    return {
      threshold: cents / 100,
      currency: bar.getAttribute('data-currency') || 'EUR'
    };
  }

  function localizeMoney(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var nodes = [];

    while (walker.nextNode()) nodes.push(walker.currentNode);

    for (var i = 0; i < nodes.length; i++) {
      var current = nodes[i].nodeValue.replace(
        'Kies je tweede ring',
        'Kies je tweede favoriet'
      );
      var localized = current.replace(/€(\d+)\.(\d{2})/g, '€$1,$2');
      if (localized !== nodes[i].nodeValue) nodes[i].nodeValue = localized;
    }
  }

  function parsePrice(text) {
    if (!text) return NaN;
    var s = text.replace(/[^\d.,]/g, '');
    if (s.indexOf(',') > -1 && s.indexOf('.') > -1) s = s.replace(/,/g, '');
    else if (s.indexOf(',') > -1) s = s.replace(',', '.');
    return parseFloat(s);
  }

  function money(amount, currency) {
    if (currency === 'EUR') return '€' + amount.toFixed(2).replace('.', ',');
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'nl', {
        style: 'currency',
        currency: currency
      }).format(amount);
    } catch (e) {
      return amount.toFixed(2) + ' ' + currency;
    }
  }

  function update(block) {
    var bars = block.querySelectorAll('.kaching-bundles__bar');
    var selected = block.querySelector('.kaching-bundles__bar--selected');

    // Keep the note only in the selected box; clear any left in other bars.
    for (var i = 0; i < bars.length; i++) {
      if (bars[i] !== selected) {
        var stray = bars[i].querySelector('.sc-free-shipping');
        if (stray) stray.remove();
      }
    }
    if (!selected) return;

    // Insert inside the box content (the label's wrapper), not as a sibling of
    // the label, otherwise it lands next to the grey box instead of in it.
    var host = selected.querySelector('.kaching-bundles__bar-wrapper') || selected;

    var priceEl = selected.querySelector(
      '.kaching-bundles__bar-price:not(.kaching-bundles__bar-full-price)'
    );
    var price = priceEl ? parsePrice(priceEl.textContent) : NaN;

    var note = selected.querySelector('.sc-free-shipping');
    if (note && note.parentNode !== host) {
      note.remove();
      note = null;
    }
    if (!note) {
      note = document.createElement('div');
      note.className = 'sc-free-shipping';
      host.appendChild(note);
    }

    var cfg = config();
    var reached = !!cfg && !isNaN(price) && price >= cfg.threshold;
    var text;
    if (!cfg) text = '';
    else if (reached) text = cfg.currency === 'EUR' ? TXT_REACHED_EUR : TXT_REACHED;
    else if (!isNaN(price)) text = TXT_LEFT.replace('%AMOUNT%', money(cfg.threshold - price, cfg.currency));
    else text = '';

    if (note.textContent !== text) note.textContent = text;
    var display = text ? '' : 'none';
    if (note.style.display !== display) note.style.display = display;
    note.classList.toggle('is-reached', reached);
  }

  function run() {
    var blocks = document.querySelectorAll('.kaching-bundles__block');
    for (var i = 0; i < blocks.length; i++) {
      localizeMoney(blocks[i]);
      update(blocks[i]);
    }

    var productPicker = document.querySelector('.kaching-bundles__choose-product');
    if (productPicker) localizeMoney(productPicker);
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      run();
    });
  }

  if (document.readyState !== 'loading') schedule();
  else document.addEventListener('DOMContentLoaded', schedule);

  // Kaching renders/re-renders async and toggles the selected bar's class on
  // click; watch childList and the class attribute, throttled to a frame.
  new MutationObserver(schedule).observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class']
  });
})();

/* === Sunny Cords — category pills in the Kaching "choose product" popup ===
   Kaching lists every bundle product in one long list. Two pills under the
   search field filter it: glasses chains vs Ring Edit®. Classification is by
   title: every Ring Edit® product carries "Ring Edit" in its title and no cord
   does (checked 20-10-2026 against both collections). Clicking the active pill
   again shows everything. Labels follow the page language; the popup is
   portaled to <body>, so it cannot read section-level translations. */
(function () {
  var LABELS = {
    nl: { cords: 'Brillenkoordjes', ring: 'Ring Edit®', empty: 'Geen producten in deze categorie' },
    en: { cords: 'Glasses chains', ring: 'Ring Edit®', empty: 'No products in this category' },
    fr: { cords: 'Chaînes de lunettes', ring: 'Ring Edit®', empty: 'Aucun produit dans cette catégorie' },
    de: { cords: 'Brillenketten', ring: 'Ring Edit®', empty: 'Keine Produkte in dieser Kategorie' }
  };
  var RING = /ring\s*edit/i;
  var HIDDEN = 'sc-bundle-filter-hidden';

  function labels() {
    var lang = (document.documentElement.lang || 'nl').slice(0, 2).toLowerCase();
    return LABELS[lang] || LABELS.en;
  }

  function pill(key, text) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'sc-bundle-filter__pill';
    b.setAttribute('data-filter', key);
    b.setAttribute('aria-pressed', 'false');
    b.textContent = text;
    return b;
  }

  function ensure(picker) {
    var bar = picker.querySelector('.sc-bundle-filter');
    if (bar) return bar;
    var txt = labels();
    bar = document.createElement('div');
    bar.className = 'sc-bundle-filter';
    bar.appendChild(pill('cords', txt.cords));
    bar.appendChild(pill('ring', txt.ring));
    var empty = document.createElement('p');
    empty.className = 'sc-bundle-filter__empty';
    empty.textContent = txt.empty;
    empty.hidden = true;
    bar.appendChild(empty);
    bar.addEventListener('click', function (e) {
      var btn = e.target.closest('.sc-bundle-filter__pill');
      if (!btn) return;
      var key = btn.getAttribute('data-filter');
      picker.setAttribute('data-sc-filter', picker.getAttribute('data-sc-filter') === key ? '' : key);
      apply(picker);
    });
    var list = picker.querySelector('.kaching-bundles__choose-product__products');
    var controls = picker.querySelector('.kaching-bundles__choose-product__controls');
    if (controls && controls.nextSibling) picker.insertBefore(bar, controls.nextSibling);
    else if (list) picker.insertBefore(bar, list);
    else picker.appendChild(bar);
    return bar;
  }

  function apply(picker) {
    var bar = ensure(picker);
    var active = picker.getAttribute('data-sc-filter') || '';
    var pills = bar.querySelectorAll('.sc-bundle-filter__pill');
    for (var i = 0; i < pills.length; i++) {
      var on = pills[i].getAttribute('data-filter') === active;
      if (pills[i].getAttribute('aria-pressed') !== String(on)) pills[i].setAttribute('aria-pressed', String(on));
    }
    var items = picker.querySelectorAll('.kaching-bundles__choose-product__product');
    var visible = 0;
    for (var j = 0; j < items.length; j++) {
      var titleEl = items[j].querySelector('.kaching-bundles__choose-product__product-title');
      var isRing = RING.test(titleEl ? titleEl.textContent : '');
      var hide = active === 'ring' ? !isRing : active === 'cords' ? isRing : false;
      if (items[j].classList.contains(HIDDEN) !== hide) items[j].classList.toggle(HIDDEN, hide);
      if (!hide) visible++;
    }
    var empty = bar.querySelector('.sc-bundle-filter__empty');
    var showEmpty = !!active && items.length > 0 && visible === 0;
    if (empty.hidden === showEmpty) empty.hidden = !showEmpty;
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      // Kaching may keep more than one picker in the DOM (hidden in the block,
      // open one portaled to <body>); handle every instance.
      var pickers = document.querySelectorAll('.kaching-bundles__choose-product');
      for (var i = 0; i < pickers.length; i++) apply(pickers[i]);
    });
  }

  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
})();

/* Keep the selected color variant visible as the first image in the desktop
   product media grid. The mobile slideshow already handles this in theme.js. */
(function () {
  /* DIEK 31-10-2026: the slider's image-set groups are rendered with Liquid's handleize
     (Elfenbeinweiss, grun, rose), but theme.js builds the lookup key by replacing every
     non [a-z0-9] character with a dash (elfenbeinwei, gr-n, ros). Same rules as handleize here,
     so /de and accented values match. */
  function handleize(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/ß/g, 'ss')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '');
  }
  // theme.js assigns theme.Product after this file and filters the slider at init, before
  // DOMContentLoaded; a setter on window.theme patches the prototype the moment it is assigned.
  if (window.theme && !Object.getOwnPropertyDescriptor(window.theme, 'Product')) {
    var productCtor;
    Object.defineProperty(window.theme, 'Product', {
      configurable: true,
      enumerable: true,
      get: function () { return productCtor; },
      set: function (ctor) {
        productCtor = ctor;
        if (ctor && ctor.prototype) ctor.prototype.getImageSetName = handleize;
      }
    });
  }

  /* Variant image sets: photos carry data-media-set="kleur_blauw" (from the alt text, see
     section.flex-pdp.media-grid). The selected colour sorts first, unset photos next; other colours get the
     --other class, which the snippet's stylesheet hides. */
  function setToken(value) {
    return String(value || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  }

  function filterVariantMediaSets(section, grid, variant) {
    var items = grid.querySelectorAll('[data-product-media-grid-item][data-media-set]');
    if (!items.length) return;

    var tokens = [];
    // Language-independent: the variant's featured media already sits in the grid with its raw set token
    // (kleur_blauw); the option values below are translated on /en, /fr, /de and only serve as fallback.
    var featuredId = variant.featured_media && variant.featured_media.id;
    var featuredItem = featuredId && grid.querySelector('[data-product-media-grid-item][data-media-id="' + featuredId + '"][data-media-set]');
    if (featuredItem) tokens.push(featuredItem.getAttribute('data-media-set'));
    var wraps = section.querySelectorAll('.variant-input-wrap[data-handle][data-index]');
    for (var w = 0; w < wraps.length; w++) {
      var value = variant[wraps[w].getAttribute('data-index')];
      if (value) tokens.push(wraps[w].getAttribute('data-handle') + '_' + setToken(value));
    }
    if (!tokens.length) return;

    var anyCurrent = false;
    for (var j = 0; j < items.length; j++) {
      if (tokens.indexOf(items[j].getAttribute('data-media-set')) !== -1) { anyCurrent = true; break; }
    }

    // Fallback: a colour without photos of its own hides nothing
    for (var i = 0; i < items.length; i++) {
      var current = tokens.indexOf(items[i].getAttribute('data-media-set')) !== -1;
      items[i].classList.toggle('media-grid__container--current', current);
      items[i].classList.toggle('media-grid__container--other', anyCurrent && !current);
    }
  }

  function showSelectedVariantMedia(section, variant) {
    var mediaId = variant && variant.featured_media && variant.featured_media.id;
    var grid = section.querySelector('.product-gallery-grid .media-grid');
    if (!grid || !variant) return;
    filterVariantMediaSets(section, grid, variant);
    if (!mediaId) return;

    var items = grid.querySelectorAll('[data-product-media-grid-item]');
    if (!items.length) return;

    var currentFirst = items[0];
    var selected = grid.querySelector(
      '[data-product-media-grid-item][data-media-id="' + mediaId + '"]'
    );

    if (!selected || selected === currentFirst || selected.parentNode !== currentFirst.parentNode) return;

    var parent = currentFirst.parentNode;
    var marker = document.createComment('variant-media-swap');
    parent.replaceChild(marker, currentFirst);
    parent.replaceChild(currentFirst, selected);
    parent.replaceChild(selected, marker);
    currentFirst.classList.remove('media-grid__container--featured');
    selected.classList.add('media-grid__container--featured');
  }

  function initVariantMediaGrids(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var sections = scope.querySelectorAll('.product-section');

    for (var i = 0; i < sections.length; i++) {
      if (sections[i].getAttribute('data-variant-media-grid-ready') === 'true') continue;

      sections[i].setAttribute('data-variant-media-grid-ready', 'true');
      sections[i].addEventListener('variantChange', function (event) {
        showSelectedVariantMedia(this, event.detail && event.detail.variant);
      });
    }
  }

  if (document.readyState !== 'loading') initVariantMediaGrids(document);
  else document.addEventListener('DOMContentLoaded', function () {
    initVariantMediaGrids(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initVariantMediaGrids(event.target);
  });
})();
